import { Divider, Stack, Typography, SvgIcon } from "@mui/material";
import { useTranslation } from "react-i18next";
import deliveryIconImg from "@static/img/icons/delivery.svg";

interface IParams {
    deliveryAddress: string;
}

export const OngoingDeliveryAddon = (props: IParams) => {
    const { deliveryAddress } = props;
    const { t } = useTranslation("addons");

    return (
        <>
            <Divider />
            <Stack direction="row" spacing={2}>
                <SvgIcon component={deliveryIconImg} />
                <Typography color="secondary" variant="small">
                    {t("deliversTo", { deliveryAddress })}
                </Typography>
            </Stack>
        </>
    );
};
